/** Información del titular de la póliza. */

import { UserRoleEnum } from '@/modules/core/models/enums'
import DocumentPersonType from '@/modules/common/common/models/APP/DocumentPersonTypeEnum'

export default class PolicyHolderSaveDocument {
  /** (String): Rol del titular. Ejemplos: TA, TN, A. */
  role?: UserRoleEnum | undefined

  /** (String): Código de nacionalidad. Ejemplo: ESPA. */
  nacionality!: string

  /** (String): Tipo de documento de identidad. Ejemplo: DNI. */
  documentType!: string

  /** (String): Número de documento de identidad. Ejemplo: 51997766L. */
  documentNumber!: string

  /** (String): La fecha de expiracion del document de identidad del asegurado. */
  documentExpirationDate!: string

  /** (String): Tipo de persona: Jurídica (PJUR) o Física (PFIS). */
  personType!: DocumentPersonType

  /** (Boolean): Consentimiento de la política de privacidad. */
  privacyPolicyConsent!: boolean

  /** (Boolean): Consentimiento para recibir noticias de Asisa. */
  asisaNewsConsent!: boolean

  /** (String): Fecha de nacimiento. Ejemplo: 1990-01-01. */
  birthDate!: string

  constructor(data: any) {
    this.role = data.role
    this.nacionality = data.nacionality
    this.documentType = data.documentType
    this.documentNumber = data.documentNumber
    this.documentExpirationDate = data.documentExpirationDate
    this.personType = data.personType
    this.privacyPolicyConsent = data.privacyPolicyConsent
    this.asisaNewsConsent = data.asisaNewsConsent
    this.birthDate = data.birthDate
  }
}
